<template>
  <div style="max-height: calc(100vh - 250px);">
    <div v-for="(prestation) in prestations" :key="prestation.prestationId" :ref="prestation.accomodationName">
      <p class="prestation-title body-strong">
        <span>{{ prestation.accomodationName }}</span>
        <span class="caption">{{ prestation.picturesAccomodation.length }} photos</span>
      </p>
      <div class="image-section">
        <img
          v-for="(image, index) in prestation.picturesAccomodation"
          :key="`image-${prestation.accomodationName}-${index}`"
          :src="getImageUrl(image)"
          :alt="`Image from ${prestation.accomodationName}`"
          :class="setImageClass(index, prestation.picturesAccomodation)"
          class="full-image"
          @click="openFullScreen(image, prestation.accomodationName)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prestations: Array,
  },
  methods: {
    getImageUrl(image) {
      return image.imgXL || image.imgLarge || image.img;
    },
    openFullScreen(image, prestationName) {
      this.$emit("openFullScreen", { image, prestationName });
    },
    setImageClass(index, images) {
      // Check if the image is the first in a cycle of 3 or in the last incomplete cycle
      const isWideImage = index % 3 === 0 || index >= images.length - (images.length % 3);
      return isWideImage ? "wide-image" : "side-by-side";
    },
  },
};
</script>

<style scoped>
.image-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px;
}

.wide-image {
  width: 100%;
  max-width: 100%;
  border-radius: 8px;
  cursor: pointer;
}

.side-by-side {
  width: calc(50% - 5px);
  max-width: calc(50% - 5px);
  border-radius: 8px;
  cursor: pointer;
}

.prestation-title {
  display: flex; /* Use flexbox to manage children alignment */
  justify-content: space-between; /* Space between title and caption */
  align-items: center; /* Align items vertically */
  color: var(--black, #000);
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: "clig" off, "liga" off;
  margin: 30px 0px 15px 0px;
  font-size: 18px !important;
}

.prestation-title span:nth-child(2){
  min-width: 50px; /* Set your desired minimum width here */
  display: inline-block; /* Ensure the span respects the min-width */
  text-align: right; /* Align the text to the right */
}
</style>
